import {IPromotionBanner} from "../../../../interfaces/templates/bannerHome/IPromotionBanner.ts";
import {useChannelsService} from "../../../../hooks/useChannelsService.tsx";
import {useEffect, useState} from "react";
import {IChannel} from "../../../../interfaces/IChannel.ts";
import {LazyLoadImage} from "react-lazy-load-image-component";

interface IProps {
    opacity: number;
    bannerData: IPromotionBanner;
}

const PromotionBannerTemplate1 = ({opacity, bannerData}: IProps) => {
    const channelsService = useChannelsService();
    const [channel, setChannel] = useState<IChannel>();
    useEffect(() => {
        if (channelsService.channels.length > 0) {
            setChannel(channelsService.channels.find(e => e.ch_id === Number(bannerData.templateContentDetails.channelId)));
        }
    }, [channelsService.channels, bannerData]);
    return (
        <div className={"relative pb-14 h-[33rem] sm:h-[25rem] md:h-[30rem] flex-shrink-0"}>
            <div className={`relative md:fixed right-0 top-0 w-full pt-14 md:pt-0`}
                 style={{opacity: opacity}}>
                <div className="relative w-full">
                    <img
                        src={`${import.meta.env.VITE_MIX_API_URL.replace("api", "")}${bannerData?.templateContentDetails?.image}`}
                        className="h-auto md:h-full max-h-[50rem] object-cover object-right max-w-full md:max-w-none md:min-w-full"
                        alt=""
                    />
                    <div
                        className="hidden md:block bottom-0 absolute w-full h-full bg-gradient-to-r from-neutral-950/100 via-40% via-neutral-950/30 to-transparent"/>
                    <div
                        className="bottom-0 absolute w-full h-full bg-gradient-to-t from-neutral-800 via-25% via-neutral-950/80 to-transparent"/>
                </div>
            </div>
            <div className="absolute flex flex-col md:pt-52 w-full px-4 bottom-0 mb-10">
                <p className="text-xl md:text-2xl text-[#008DD2] font-medium">
                    {bannerData.templateContentDetails.category}
                </p>
                <p className="text-3xl md:text-5xl mt-3">{bannerData.title}</p>
                <p className="mt-4 text-lg md:text-xl">
                    {bannerData.templateContentDetails.description}
                </p>
                <div className="flex items-center space-x-2 mt-4">
                    <LazyLoadImage
                        alt=""
                        effect="opacity"
                        className={`w-9 h-9 md:w-10 md:h-10 py-0 align-middle`}
                        src={`${import.meta.env.VITE_MIX_CHANNEL_LOGO_URL}/${channel?.logo}`} // use normal <img> attributes as props
                    />
                    <p className={"text-base md:text-xl"}>{channel?.name}</p>
                </div>
            </div>
        </div>
    );
};

export default PromotionBannerTemplate1;